import { IPersona } from "@/interfaces/persona.interface"
import { api } from "@/lib/api/axios"
import {
  AddressPerson,
  BankAccountPerson,
  Custom,
  HealthPerson,
  JuridicPerson,
  Profile
} from "@/types/person"

const USERS_API_PATH = '/person'

export interface PersonSearchResult {
  id: number
  name: string
  email: string
  document: string
  role: string | null
  avatar: string | null
}

export const personService = {
  searchPersons: async (query: string): Promise<PersonSearchResult[]> => {
    return await api.get<PersonSearchResult[]>(`${USERS_API_PATH}/search`, {
      params: { q: query }
    })
  },
  updateProfile: async (payload: Profile) => {
    return api.patch(`${USERS_API_PATH}/profile`, payload)
  },
  registerAddress: async (payload: AddressPerson) => {
    const { id, ...addressData } = payload;
    return api.post(`${USERS_API_PATH}/address`, addressData)
  },
  updateAddress: async (payload: AddressPerson) => {
    const { id, ...addressData } = payload;
    return api.patch(`${USERS_API_PATH}/address/${id}`, addressData)
  },
  updateHealth: async (payload: HealthPerson) => {
    const { id, ...healthData } = payload;
    return api.patch(`${USERS_API_PATH}/health`, healthData)
  },
  registerBankDetails: async (payload: BankAccountPerson) => {
    const { id, ...bankAccountData } = payload;
    return api.post(`${USERS_API_PATH}/bank-account`, bankAccountData)
  },
  updateBankDetails: async (payload: BankAccountPerson) => {
    const { id, ...bankAccountData } = payload;
    return api.patch(`${USERS_API_PATH}/bank-account/${id}`, bankAccountData)
  },
  updateJuridicPerson: async (payload: JuridicPerson) => {
    const { id, ...juridicData } = payload;
    return api.patch(`${USERS_API_PATH}/juridic-person`, juridicData)
  },
  uploadDoc: async (payload: FormData) => {
    return api.post<ResponseDoc>(`${USERS_API_PATH}/upload-document`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  updateCustom: async (payload: Custom) => {
    return api.patch(`${USERS_API_PATH}/person-customization`, payload)
  },
  me: async () => {
    return api.get<IPersona>(`${USERS_API_PATH}/me`)
  },
}
interface ResponseDoc {
  message: string;
  url: string;
  documentType: string;
}